import { Link, useLocation } from "react-router-dom";

/**
 * Floating pill that lets us flip between landing-page copy variants while
 * we're A/B comparing on preview/dev only. **Hidden in production** — this
 * component returns null if the current hostname isn't a known dev/preview
 * host, so real visitors never see the V1/V2/V3 controls.
 */
const VERSIONS = [
  { label: "V1", to: "/v1", matches: (p) => p === "/v1" },
  { label: "V2", to: "/v2", matches: (p) => p === "/v2" },
  { label: "V3", to: "/v3", matches: (p) => p === "/v3" },
  { label: "V4", to: "/v4", matches: (p) => p === "/v4" },
  { label: "V5", to: "/", matches: (p) => p === "/" || p === "/v5" },
  { label: "All", to: "/preview-all", matches: (p) => p === "/preview-all" },
];

// Preview / dev hosts where the switcher IS shown.
// Anything else (theblkcommunity.com, goldverify-market.emergent.host,
// custom production domains) hides it.
const PREVIEW_HOSTS = [
  "localhost",
  "127.0.0.1",
  ".preview.emergentagent.com",
];

function isPreviewHost() {
  if (typeof window === "undefined") return false;
  const h = window.location.hostname;
  return PREVIEW_HOSTS.some((p) => (p.startsWith(".") ? h.endsWith(p) : h === p));
}

export default function VersionSwitcher() {
  const { pathname } = useLocation();

  // Production visitors never see this component.
  if (!isPreviewHost()) return null;

  return (
    <div
      className="fixed left-4 bottom-4 z-50 flex items-center gap-1 bg-tbc-navy/95 backdrop-blur-md text-white rounded-full pl-3 pr-1.5 py-1.5 shadow-2xl border border-white/10"
      data-testid="version-switcher"
    >
      <span className="text-[10px] uppercase tracking-[0.18em] text-tbc-gold mr-2 font-medium">
        Preview
      </span>
      {VERSIONS.map((v) => {
        const active = v.matches(pathname);
        return (
          <Link
            key={v.label}
            to={v.to}
            className={`text-xs font-medium px-3 py-1.5 rounded-full transition-colors ${
              active
                ? "bg-tbc-gold text-tbc-navy"
                : "text-white/80 hover:text-white hover:bg-white/10"
            }`}
            data-testid={`version-switcher-${v.label.toLowerCase()}`}
          >
            {v.label}
          </Link>
        );
      })}
    </div>
  );
}
